import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Reason - ПРИЧИНА НЕДОСТУПНОСТИ ДЕЙСТВИЯ, словами рядом с кнопкой.
 *
 * Решение владельца 2026-09-26 (5), доведённое до правила единицей 21:
 * заблокированная главная кнопка рисуется `secondary` (это делает сам
 * `Button`), а почему её нельзя нажать - написано рядом. Прозрачность 0,5
 * признаком не считается: серая кнопка без слов читается как плохая вёрстка,
 * а не как «пока нельзя».
 *
 * Связь с кнопкой - `aria-describedby` кнопки на `id` причины: чтец
 * прочитает её вместе с именем кнопки. Эту связь требуют ворота `UI-10`
 * (`pnpm ui:check` - статически, `e2e/class-buttons.spec.ts` - живьём).
 *
 * Роль одна - компонент один: пометку `data-reason` ставит только он
 * (правило `UI-4`).
 */
export function Reason({ id, children, className, ...rest }) {
    return (_jsx("p", { ...rest, id: id, "data-reason": true, className: ['text-foreground/80 text-sm', className ?? ''].filter(Boolean).join(' '), children: children }));
}
//# sourceMappingURL=Reason.js.map